import { configFetch as fetch } from '@laigu/utils';

// 版本隔离
export const uploadImage = ({ file, type, onUploadProgress }) => {
  const formData = new FormData();
  formData.append('file', file);

  if (type) {
    formData.append('type', type);
  }

  return fetch({
    url: `/upload`,
    method: 'file',
    data: formData,
    onUploadProgress
  });
};
